<div class="kum-container">
  <div class="kum-head">
    <h2>Nutzerverwaltung</h2>
    <app-button
      (click)="openAddDialog()"
      icon="/assets/add_white.svg"
      label="Neuer Kundennutzer"
      type="primary-icon-button"
    />
  </div>
  <div class="kum-tabs" role="tablist" aria-label="Kundennutzerstatus">
    @for (tab of tabs; track tab.id) {
      <button
        type="button"
        class="kum-tab"
        role="tab"
        [class.active]="activeTab === tab.id"
        [attr.aria-selected]="activeTab === tab.id"
        (click)="selectTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    }
  </div>
  <app-keycloak-user-management-filter (filterListEvent)="filterUsers($event)" />
  @if (isLoading) {
    <app-loading-animation />
  }
  @if (!isLoading && error === null) {
    <app-keycloak-user-management-table
      [users]="users"
      [totalPages]="totalPages"
      [customerNames]="customerNames"
      [emptyMessage]="emptyTableMessage"
      (editClick)="openEditDialog($event)"
      (paginationChangeEvent)="filterUsers($event.params)"
    />
  }
  @if (error) {
    <div class="error-container"><app-error [error]="error" /></div>
  }
</div>
<app-keycloak-user-management-dialog
  [allowDeactivate]="activeTab === 'active'"
  (addUser)="onAddUser($event)"
  (updateUser)="onUpdateUser($event)"
  (recreateUser)="onRecreateUser($event)"
  (deactivateUser)="onDeactivateUser($event)"
  (reactivateUser)="onReactivateUser($event)"
  (deleteUser)="onDeleteUser($event)"
  (deleteDatabaseUser)="onDeleteDatabaseUser($event)"
/>
